module.exports = __webpack_public_path__ + "static/media/mat.89138eab.png";